export default __webpack_public_path__ + "static/media/successYellowBg.a3356dd8.svg";